// ReusableDialog.js
import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Divider } from "@mui/material";

const ReusableDialog = (props) => {
  const {
    text,
    open,
    showSecondButton,
    secondButtonText,
    mainButtonText,
    onClose,
    handleMainButtonClick,
    error,
    title,
  } = props;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <Divider />
      <DialogContent>{text}</DialogContent>
      <DialogActions>
        {showSecondButton && (
          <Button
            onClick={onClose}
            color={error ? "error" : "primary"}
            variant="outlined"
            style={{ fontWeight: 700 }}
          >
            {secondButtonText || "Cancel"}
          </Button>
        )}

        <Button
          onClick={handleMainButtonClick}
          variant="contained"
          color={error ? "error" : "primary"}
          style={{ fontWeight: 700 }}
        >
          {mainButtonText || "OK"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReusableDialog;
